/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * jeeves/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * InvocationSource identifies the entity responsible for creating a run.

 - INVOCATION_SOURCE_UNSPECIFIED: Unspecified invocation source.
 - INVOCATION_SOURCE_MANUAL: Run was manually initiated by a user.
 - INVOCATION_SOURCE_TRIGGER: Run was triggered by an event or trigger.
 - INVOCATION_SOURCE_SCHEDULE: Run was initiated by a schedule.
 - INVOCATION_SOURCE_PAT: Run was initiated via a Personal Access Token (PAT).
 - INVOCATION_SOURCE_TEST: Run was initiated by Quill agent for testing draft automations.
 */
export type V1InvocationSource =
  (typeof V1InvocationSource)[keyof typeof V1InvocationSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1InvocationSource = {
  INVOCATION_SOURCE_UNSPECIFIED: 'INVOCATION_SOURCE_UNSPECIFIED',
  INVOCATION_SOURCE_MANUAL: 'INVOCATION_SOURCE_MANUAL',
  INVOCATION_SOURCE_TRIGGER: 'INVOCATION_SOURCE_TRIGGER',
  INVOCATION_SOURCE_SCHEDULE: 'INVOCATION_SOURCE_SCHEDULE',
  INVOCATION_SOURCE_PAT: 'INVOCATION_SOURCE_PAT',
  INVOCATION_SOURCE_TEST: 'INVOCATION_SOURCE_TEST',
} as const;
